
import { defineComponent, ref } from "vue";
import IconButton from "@/components/IconButton.vue";

export default defineComponent({
  name: "ChatUploadImage",
  inheritAttrs: false,
  components: {
    IconButton
  },

  setup(props, { emit }) {
    const file = ref<null | HTMLElement>(null);

    function clickFileUpload() {
      if (file.value) {
        file.value.click();
      }
    }

    function emitChange(event: Event) {
      emit("change", event);
    }

    return { file, clickFileUpload, emitChange };
  }
});
